
type PermissionTypesArray = {
    [index: number]: string;
};

export const PermissionTypes: PermissionTypesArray = {
    /**
     * @description Leitura
     */
    0: 'Read',
    
    /**
     * @description Inserção
     */
    1: 'Create',
    
    /**
     * @description Atualização
     */
    2: 'Update',
    
    /**
     * @description Exclusão
     */
    3: 'Delete',
    
    /**
     * @description Enviar para aprovação
     */
    4: 'SubmitApproval',
    
    /**
     * @description Aprovar Compliance
     */
    5: 'ComplianceApproval',
    
    /**
     * @description Aprovar Crédito
     */
    6: 'CreditApproval',
    
    /**
     * @description Aprovar Instrumento
     */
    7: 'InstrumentApproval',
    
    /**
     * @description Aprovar Liquidação
     */
    8: 'LiquidationApproval',
    
    /**
     * @description Revisar Pagamento
     */
    9: 'LiquidationPaymentRevision',
    
    /**
     * @description Clonar Registro
     */
    10: 'Clone',
    
    /**
     * @description Atualizar Documentos
     */
    11: 'UploadDocs',
    
    /**
     * @description Gerar Contrato
     */
    12: 'DraftPreview',
    
    /**
     * @description Gerar Contrato de Cessão
     */
    13: 'AssigmentPreview',
    
    /**
     * @description Enviar documentos por e-mail
     */
    14: 'SendAssigmentEmail',
    
    /**
     * @description Atualização manual
     */
    15: 'ManualUpdate',
    
    /**
     * @description Remover Bloqueio
     */
    16: 'RemoveBlock',
    
    /**
     * @description Validação de assinaturas
     */
    17: 'SignatureValidation',
    
    /**
     * @description Iniciar averbação de saque aniversário
     */
    18: 'RegisterFgtsSaqueAniversario',
    
    /**
     * @description Cancelar
     */
    19: 'Cancel',
    
    /**
     * @description Atribuir Registro
     */
    20: 'AssignRecord',
    
    /**
     * @description Enviar notificação
     */
    21: 'SendNotification',
    
    /**
     * @description Restaurar Registro
     */
    22: 'RestoreRecord',
    
    /**
     * @description Consultar Dataset
     */
    23: 'ReadDataSet',
    
    /**
     * @description Solicitar Dataset
     */
    24: 'RequestDataSet',
    
    /**
     * @description Atribuir fundo
     */
    25: 'SetFund',
    
    /**
     * @description Integração com WebCred
     */
    26: 'SendToWedCred',
    
    /**
     * @description Concluir assinaturas
     */
    27: 'FinishSignature',
    
    /**
     * @description Vincular novo operador à conta
     */
    28: 'RequestNewOperator',
    
    /**
     * @description Visualizar todos os operadores pendentes
     */
    29: 'ViewPendingOperators',
    
    /**
     * @description Aprovar operador (admin)
     */
    30: 'AdminApproveOperator',
    
    /**
     * @description Cancelar (admin)
     */
    31: 'AdminCancel',
    
    /**
     * @description Visualizar acesso concedidos à conta bancária
     */
    32: 'ViewOperators',
    
    /**
     * @description Realizar abertura de conta bancária
     */
    33: 'OpenBankAccount',
    
    /**
     * @description Aprovar Limites
     */
    34: 'ApproveBankAccountLimit',
    
    /**
     * @description Solicitar Limite
     */
    35: 'RequestBankAccountLimit',
    
    /**
     * @description Aprovar beneficiário
     */
    36: 'AdminApproveBeneficiary',
    
    /**
     * @description Aprovações pendentes
     */
    37: 'ViewPendingApprovals',
    
    /**
     * @description Simular operação
     */
    38: 'SimulateAmortization',
    
    /**
     * @description Visualizador de todas as contas bancárias
     */
    39: 'ViewAllBankAccounts',
    
    /**
     * @description Aprovador master de todas as contas bancárias
     */
    40: 'MasterApproverAllBankAccounts',
    
    /**
     * @description Adicionar lançamentos
     */
    41: 'AddAccountEntry',
    
    /**
     * @description Iniciar processo de assinatura do documento
     */
    42: 'StartSignatureWorkFlow',
    
    /**
     * @description Cancelar processo de assinatura de documentos
     */
    43: 'CancelSignatureWorkFlow',
    
    /**
     * @description Reenviar Notificação
     */
    44: 'ResendNotificationSignatureWorkFlow',
    
    /**
     * @description Habilitar Usuário
     */
    45: 'EnableUser',
    
    /**
     * @description Desabilitar Usuário
     */
    46: 'DisableUser',
    
    /**
     * @description Permitir atualizações das permissões no ambiente do operador
     */
    47: 'AllowUpdatePermissionsSameTenant',
    
    /**
     * @description Aprovar Garantia
     */
    48: 'ApproveWarranty',
    
    /**
     * @description Aprovar Reserva de Margem
     */
    49: 'ApproveMarginReserve',
    
    /**
     * @description Reiniciar esteira de processamento
     */
    50: 'RestartWorkflow',
    
    /**
     * @description Encerrar Conta
     */
    51: 'TerminateAccount',
    
    /**
     * @description Incluir Beneficiário no produto de crédito
     */
    52: 'IncludeBeneficiaryProduct',
    
    /**
     * @description Atualizar tarifa da gestão de cobrança
     */
    53: 'UpdateBillingCosts',
    
    /**
     * @description Aprovar Revisão de Garantia
     */
    54: 'ApproveWarrantyRevision',
    
    /**
     * @description Editar Extensões do Tenant
     */
    55: 'UpdateTenantExtensions'
};
